// extracted by mini-css-extract-plugin
module.exports = {"root":"N6Vyl","wrapper":"_3-Dmi"};